import { useLogout } from "@fuze/hub-authorization"

export default function useInternalLogout() {
  const logout = useLogout()
  return logout
}
